import React, { useState, useRef, useEffect } from "react";
import { CircularProgress } from "@mui/material";
import AxiosInstance from "../../../utils/AxiosInstance";
import handleError from "../../../constants/handleError";
import { useNetwork } from "../../../context/NetworkContext";
import { useShowAlert } from "../../../context/AlertContext";
import CurrencyConverter from "@heartinz/currency_subunit_converter";
import { useContextApi } from "../../../context/ContextApi";
import { AddIcon, XIcon } from "../../../constants/Icons";

const AddRecharge = ({
  onClose,
  onAdd,
  isBtnLoading,
  // rechargeSuggest = [],
}) => {
  const operatorRef = useRef();
  const numberRef = useRef();
  const walletRef = useRef();
  const amountRef = useRef();
  const noteRef = useRef();
  const {useEscapeKey}=useContextApi();
  const hasFetched = useRef(false);
  // const rechargeSuggestionRef = useRef();
  const { checkNetwork } = useNetwork();
  const showAlert = useShowAlert();
  const [isRechargeData, setRechargeData] = useState({
    operator: "",
    number: "",
    wallet: "",
    amount: 0,
    note: "",
    walletId: "",
    isStock: false,
    isLock: "SALEPRICE",
    description: "",
    walletBalance: 0,
  });
  const [listWallet, setListWallet] = useState([]);
  const [errorMessage, setErrorMessage] = useState(null);
  const [suggestions, setSuggestions] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [highlightedIndex, setHighlightedIndex] = useState(-1);
  const [filteredSuggestions, setFilteredSuggestions] = useState([]);
  const suggestionRef = useRef([]);
  const desRef = useRef();
  // const [showRechargePopup, setShowRechargePopup] = useState(false);
  // const [filteredSuggestions, setFilteredSuggestions] = useState([]);

  // useEffect(() => {
  //   if (
  //     isRechargeData?.operator &&
  //     !filteredSuggestions?.some(
  //       (item) => item?.operator === isRechargeData?.operator
  //     )
  //   ) {
  //     setFilteredSuggestions((prev) => [
  //       ...prev,
  //       { operator: isRechargeData?.operator, id: Date.now() },
  //     ]);
  //   }
  // }, [isRechargeData?.operator, filteredSuggestions]);

  const handleClose = () => {
    setRechargeData({
      operator: "",
      number: "",
      wallet: "",
      amount: 0,
      note: "",
    });
    setErrorMessage("");
    onClose();
  };
  useEscapeKey(handleClose);
  const fetchSuggestions = async () => {
    try {
      if (!checkNetwork()) return;
      const response = await AxiosInstance.get(
        `module/recharge/list-recharge-operator-suggestion`
      );
      setSuggestions(response.data.results);
      setShowSuggestions(true);
    } catch (error) {
      handleError(error, showAlert);
      return false;
    }
  };

  const handleListRechargeWallet = async () => {
    try {
      if (!checkNetwork()) return;
      const response = await AxiosInstance.get(
        `module/recharge/list-recharge-wallet`
      );
      setListWallet(response?.data?.results || []);
      return response.data.results;
    } catch (error) {
      handleError(error, showAlert);
      return false;
    }
  };

  const handleRechargeDate = (event) => {
    event.preventDefault();
    if (!validateForm()) return;
    onAdd(isRechargeData);
    onClose();
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    let inputValue = value;
    setErrorMessage("");
    if (name === "amount") {
      if (value === "") {
        inputValue = "";
      } else {
        const validAmountPattern = /^\d*\.?\d{0,2}$/;
        if (!validAmountPattern.test(value)) return;

        const parsedValue = parseFloat(value);
        inputValue = isNaN(parsedValue) || parsedValue < 0 ? 0 : value;
      }
    }

    if (name === "number") {
      if (!/^[a-zA-Z0-9\s]*$/.test(value)) return;
      // if (value.length > 10) return;
      inputValue = value;
    }

    if (name === "operator") {
      if (/\d/.test(value)) return; // Disallow digits
      inputValue = value.replace(/^\s+/, "").replace(/\s{2,}/g, " ");
      const filtered = suggestions?.filter((s) =>
        s.operator.toLowerCase().includes(value.toLowerCase())
      );
      setFilteredSuggestions(filtered);
      setShowSuggestions(true);
    }

    let updatedData = {
      ...isRechargeData,
      [name]: inputValue,
    };

    if (name === "wallet") {
      const selectedWallet = listWallet.find(
        (item) => item.walletname === inputValue
      );
      updatedData.walletId = selectedWallet?._id || "";
      updatedData.walletBalance = CurrencyConverter.toCurrency(
        selectedWallet?.walletbalance || 0,
        "INR"
      );
    }

    setRechargeData(updatedData);
  };

  const validateForm = () => {
    const { operator, number, wallet, amount, walletBalance } = isRechargeData;
    const newErrors = {};

    // Operator validation
    if (!operator || operator.trim() === "") {
      newErrors.operator = "Operator is required.";
      operatorRef?.current?.focus();
    } else if (operator?.length < 3) {
      newErrors.operator = "Operator must be between 2-100 characters";
      operatorRef?.current?.focus();
    } else if (/\d/.test(operator)) {
      newErrors.operator = "Operator should not contain numbers.";
      operatorRef?.current?.focus();
    }

    // Number validation
    else if (!number || number.trim() === "") {
      newErrors.number = "Number is required.";
      numberRef?.current?.focus();
    } else if (!/^[a-zA-Z0-9\s]+$/.test(number)) {
      newErrors.number = "Field is Required";
      numberRef?.current?.focus();
    }

    // Wallet validation
    else if (!wallet || wallet.trim() === "") {
      newErrors.wallet = "Please select a wallet.";
      walletRef?.current?.focus();
    } else {
      // Amount validation
      const parsedAmount = parseFloat(amount);
      if (isNaN(parsedAmount) || parsedAmount <= 0) {
        newErrors.amount = "Enter a valid amount greater than 0.";
        amountRef?.current?.focus();
      } else if (parsedAmount > walletBalance) {
        newErrors.amount = "Your wallet don't have insuficient Balance";
        amountRef?.current?.focus();
      } else {
        // const decimalPart = amount.toString().split(".")[1];
        // if (!decimalPart || decimalPart.length !== 2) {
        //   newErrors.amount =
        //     "Amount must have exactly two decimal places (e.g., 22.22).";
        // }
      }
    }
    setErrorMessage(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  const handleEnterNavigation = (e, nextRef, fieldName) => {
    if (e.key === "Enter") {
      e.preventDefault();

      const value = isRechargeData[fieldName]?.toString().trim();
      let error = "";

      switch (fieldName) {
        case "operator":
          if (!value) error = "Operator is required.";
          else if (/\d/.test(value))
            error = "Operator should not contain numbers.";
          break;
        case "number":
          if (!value) error = "Number is required.";
          else if (!/^[a-zA-Z0-9\s]+$/.test(value)) error = "Field is Required";
          break;
        case "wallet":
          if (!value) error = "Please select a wallet.";
          break;
        case "amount":
          const parsed = parseFloat(value);
          if (isNaN(parsed) || parsed <= 0)
            error = "Enter a valid amount greater than 0.";
          break;
        default:
          break;
      }

      if (error) {
        setErrorMessage((prev) => ({
          ...prev,
          [fieldName]: error,
        }));
        return;
      } else {
        setErrorMessage((prev) => {
          const updated = { ...prev };
          delete updated[fieldName];
          return updated;
        });

        if (typeof nextRef === "function") {
          nextRef();
        } else {
          nextRef?.current?.focus();
        }
      }
    }
  };

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (operatorRef.current && !operatorRef.current.contains(e.target)) {
        setShowSuggestions(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    if (highlightedIndex >= 0 && suggestionRef.current[highlightedIndex]) {
      suggestionRef.current[highlightedIndex].scrollIntoView({
        block: "nearest",
        behavior: "smooth",
      });
    }
  }, [highlightedIndex]);

  useEffect(() => {
    if (showSuggestions) {
      setFilteredSuggestions(suggestions);
    }
  }, [suggestions, showSuggestions]);

  useEffect(() => {
    if (hasFetched.current) return;
    hasFetched.current = true;
    fetchSuggestions();
    handleListRechargeWallet();
  }, []);

  useEffect(() => {
    operatorRef?.current?.focus();
  }, []);

  // useEffect(() => {
  //   const handleClickOutside = (e) => {
  //     if (
  //       rechargeSuggestionRef?.current &&
  //       !rechargeSuggestionRef?.current?.contains(e.target)
  //     ) {
  //       setShowRechargePopup(false);
  //     }
  //   };
  //   document.addEventListener("mousedown", handleClickOutside);
  //   return () => document.removeEventListener("mousedown", handleClickOutside);
  // }, []);

  return (
    <div>
      <div className="modal-backdrop show"></div>
      <div
        className="modal show d-block"
        id="StoreModal"
        tabIndex="0"
        aria-modal="true"
        role="dialog"
      >
        <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable">
          <div className="modal-content">
            <div className="modal-header">
              <h6 className="modal-title">Add Recharge</h6>
              <button
                type="button"
                onClick={handleClose}
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <div className="card w-100 radius-10 mb-0 shadow-none">
                <div className="card-body p-0">
                  <form className="row g-3">
                    <div className="col-md-6">
                      <label htmlFor="description" className="form-label">
                        Operator <small className="text-danger">*</small>
                      </label>
                      <div className="position-relative">
                        <input
                          ref={operatorRef}
                          type="text"
                          autoComplete="off"
                          name="operator"
                          maxLength="5000"
                          className="form-control"
                          value={isRechargeData?.operator}
                          onChange={handleChange}
                          onFocus={() => {
                            // handleSuggestEstimate();
                            setShowSuggestions(true);
                            setFilteredSuggestions(suggestions);
                          }}
                          // onKeyDown={(e) =>
                          //   handleEnterNavigation(e, numberRef, "operator")
                          // }
                          onKeyDown={(e) => {
                            const key = e.key;
                            if (e.key === "ArrowDown") {
                              e.preventDefault();
                              setHighlightedIndex((prev) =>
                                Math.min(
                                  prev + 1,
                                  filteredSuggestions.length - 1
                                )
                              );
                            } else if (e.key === "ArrowUp") {
                              e.preventDefault();
                              setHighlightedIndex((prev) =>
                                Math.max(prev - 1, 0)
                              );
                            } else if (e.key === "Tab" || e.key === "Enter") {
                              if (
                                highlightedIndex >= 0 &&
                                filteredSuggestions[highlightedIndex]
                              ) {
                                e.preventDefault();
                                const selected =
                                  filteredSuggestions[highlightedIndex];
                                setRechargeData((prev) => ({
                                  ...prev,
                                  operator: selected.operator,
                                }));
                                setShowSuggestions(false);
                                setHighlightedIndex(-1);

                                setTimeout(() => {
                                  desRef.current?.focus();
                                }, 10);

                                // Call handleEnterKey to move focus properly
                                handleEnterNavigation(e, numberRef, "operator");
                              } else {
                                // If no suggestion is highlighted, use the normal enter key handler
                                handleEnterNavigation(e, numberRef, "operator");
                              }
                            } else {
                              handleEnterNavigation(e, numberRef, "operator");
                            }
                          }}
                        />
                        {showSuggestions && filteredSuggestions.length > 0 && (
                          <ul className="suggestions-list suggestions-list_Quick">
                            {filteredSuggestions.map((item, index) => (
                              <li
                                key={item._id}
                                ref={(e) => (suggestionRef.current[index] = e)}
                                className={`suggestion-item text-muted ${
                                  index === highlightedIndex
                                    ? "highlighted"
                                    : ""
                                }`}
                                onMouseDown={(e) => {
                                  e.preventDefault();
                                  e.stopPropagation();
                                  setRechargeData((prev) => ({
                                    ...prev,
                                    operator: item.operator,
                                  }));
                                  setShowSuggestions(false);
                                  setErrorMessage("");
                                  setHighlightedIndex(-1);
                                  setTimeout(() => {
                                    desRef.current?.focus();
                                  }, 10);
                                }}
                              >
                                {item.operator}{" "}
                                {/* <span className="badge bg-label-retro float-end">
                                  used {item.usageCount}
                                </span> */}
                              </li>
                            ))}
                          </ul>
                        )}

                        {showSuggestions &&
                          filteredSuggestions.length === 0 && (
                            <ul className="suggestions-list">
                              <li className="suggestion-item  text-muted">
                                No suggestions found
                              </li>
                            </ul>
                          )}
                      </div>
                      {errorMessage && (
                        <div className="invalid-feedback">
                          {errorMessage.operator}
                        </div>
                      )}
                    </div>
                    <div className="col-md-6">
                      <label htmlFor="description" className="form-label">
                        Number <small className="text-danger">*</small>
                      </label>
                      <input
                        ref={numberRef}
                        type="text"
                        name="number"
                        autoComplete="off"
                        maxLength="5000"
                        className="form-control"
                        value={isRechargeData?.number}
                        onChange={handleChange}
                        onKeyDown={(e) =>
                          handleEnterNavigation(e, walletRef, "number")
                        }
                      />
                      {errorMessage && (
                        <div className="invalid-feedback">
                          {errorMessage.number}
                        </div>
                      )}
                    </div>
                    <div className="col-md-6">
                      <label className="form-label">
                        Select Wallet{" "}
                        <span className="text-danger me-1">*</span>
                        <span className="badge  rounded-pill bg-label-plus">
                          ₹{isRechargeData.walletBalance}
                        </span>
                      </label>
                      <select
                        ref={walletRef}
                        className="form-select"
                        name="wallet"
                        value={isRechargeData.wallet}
                        onChange={handleChange}
                        onKeyDown={(e) =>
                          handleEnterNavigation(e, amountRef, "wallet")
                        }
                      >
                        <option value="">Select</option>
                        {listWallet?.map((item) => (
                          <option key={item?._id} value={item?.walletname}>
                            {item?.walletname}{" - "}<span className="badge  rounded-pill bg-label-plus">
                          ₹{CurrencyConverter.toCurrency(item?.walletbalance ||0,'INR')}
                        </span>
                          </option>
                        ))}
                      </select>
                      {errorMessage && (
                        <div className="invalid-feedback">
                          {errorMessage.wallet}
                        </div>
                      )}
                    </div>

                    <div className="col-md-6">
                      <label htmlFor="description" className="form-label">
                        Amount <small className="text-danger">*</small>
                      </label>
                      <input
                        ref={amountRef}
                        type="text"
                        autoComplete="off"
                        name="amount"
                        maxLength="5000"
                        className="form-control"
                        value={isRechargeData?.amount}
                        onChange={handleChange}
                        onFocus={(e) => e.target.select()}
                        onKeyDown={(e) =>
                          handleEnterNavigation(e, noteRef, "amount")
                        }
                      />
                      {errorMessage && (
                        <div className="invalid-feedback">
                          {errorMessage.amount}
                        </div>
                      )}
                    </div>
                    <div className="col-md-12">
                      <label htmlFor="description" className="form-label">
                        Notes
                      </label>
                      <input
                        ref={noteRef}
                        type="text"
                        autoComplete="off"
                        name="note"
                        maxLength="5000"
                        className="form-control"
                        value={isRechargeData?.note}
                        onChange={handleChange}
                        onKeyDown={(e) =>
                          handleEnterNavigation(e, () => handleRechargeDate(e))
                        }
                      />
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <div className="modal-footer d-block">
              <button
                onClick={handleClose}
                type="button"
                data-bs-dismiss="modal"
                className="btn btn-outline-secondary text-left"
              >
                <XIcon/> Cancel
              </button>

              {isBtnLoading ? (
                <button className="btn btn-success pb-0 text-right" disabled>
                  <CircularProgress size={22} className="text-white" />
                </button>
              ) : (
                <button
                  type="button"
                  className="btn btn-primary text-right"
                  onClick={handleRechargeDate}
                >
                  <AddIcon/> Add
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddRecharge;
